// @flow
import React from 'react'
import gql from 'graphql-tag'
import Redirect from 'components/atoms/Redirect'
import { graphql } from 'react-apollo'
import NotificationSettingPage from 'components/pages/NotificationSettingPage'
import { bindActionCreators } from 'redux'
import { viewerFragment } from 'api/fragments'
import {
  actions as eventSettingActions,
  validate as validateEventSetting,
} from 'redux/modules/eventSetting'
import 'url-search-params-polyfill'
import RestClient, {
  createRestInterface,
} from 'frontend_core/dist/api/rest/client'
import withPage from 'server/withPage'
import NotificationSettingUseCase, {
  type NotificationSettingUseCaseType,
} from 'usecases/NotificationSettingUseCase'
import { checkTokenExpired } from 'helpers/auth'

type Props = {
  config: {},
  data: {
    viewer: {},
  },
  notificationSettingUseCase: NotificationSettingUseCaseType,
  eventSetting: {},
  network: {
    redirectUrl: string,
    isLoading: boolean,
  },
}

class NotificationSettingPageContainer extends React.Component<Props> {
  componentDidMount(props) {
    const { notificationSettingUseCase } = this.props
    notificationSettingUseCase.initialize()
  }

  render() {
    const {
      config,
      data,
      network,
      eventSetting,
      notificationSettingUseCase,
    } = this.props

    if (!!network.redirectUrl) {
      return <Redirect to={network.redirectUrl} />
    }

    return (
      <NotificationSettingPage
        config={config}
        currentUser={data?.viewer}
        onSubmit={notificationSettingUseCase.updateSetting}
        onClickBack={() => window.history.back()}
        onChange={notificationSettingUseCase.changeEventSettingCheckState}
        setting={eventSetting}
        isLoading={network.isLoading}
      />
    )
  }
}

const pageQuery = gql`
query SettingPage {
  viewer {
    ${viewerFragment}
  }
}`

const withData = graphql(pageQuery, {
  skip: checkTokenExpired(),
  options: props => {
    const variables = {}
    return { variables }
  },
})

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setEventSetting: eventSettingActions.setEventSetting,
    fetchEventSetting: eventSettingActions.fetchEventSetting,
    updateEventSetting: eventSettingActions.updateEventSetting,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withPage(
  NotificationSettingUseCase(NotificationSettingPageContainer),
  mapStateToProps,
  mapDispatchToProps,
  {
    graphql: withData,
  },
)
